export const LINK_TYPES = {
    WEB_ADDRESS: 'webAddress',
    EMAIL_ADDRESS: 'emailAddress',
    PICTURE_URL: 'pictureUrl'
};
